import { keyframes } from 'styled-components';

export const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const getElevation = (elevation?: boolean, float?: boolean): boolean => {
  if (typeof elevation !== 'undefined') {
    return elevation;
  }

  if (typeof elevation === 'undefined' && typeof elevation !== 'undefined' && float) {
    return float;
  }

  return true;
};
